/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DropdownMenu, Checkbox, Badge, FlexCol } from 'sarsaparilla';

export default function StoryActivityFilter({ aggregations, selectedFilters, onApply }) {
    const [filters, setFilters] = useState([...selectedFilters]);

    function getCount(attribute) {
        if (aggregations) {
            return aggregations[attribute] || 0;
        }
        return 0;
    }

    // Find the total amounts
    const boatingTotal = getCount('Boating');
    const campingTotal = getCount('Camping');
    const climbingTotal = getCount('Climbing');
    const fishingTotal = getCount('Fishing');
    const hikingTotal = getCount('Hiking');
    const huntingTotal = getCount('Hunting');
    const ohvTotal = getCount('Off-Highway Vehicle');
    const petFriendlyTotal = getCount('Pet Friendly');
    const rvCampingTotal = getCount('RV Camping');
    const waterSportsTotal = getCount('Water Sports');
    const wildlifeViewingTotal = getCount('Wildlife Viewing');

    const onFilterChange = (event) => {
        if (event.target.checked) {
            const newFilters = [...filters];
            newFilters.push(event.target.value);
            setFilters(newFilters);
        } else {
            setFilters(filters.filter((f) => f !== event.target.value));
        }
    };

    const onApplyClicked = () => {
        onApply(filters);
    };

    const id = 'ugc-story-activity-filter';

    return (
        <FlexCol xs={12} md="variable">
            <DropdownMenu
                label="Activity Type"
                id="ugc-story-activity-type"
                badgeCount={selectedFilters.length === 0 ? null : selectedFilters.length}
                onApply={onApplyClicked}
                clickTagCategory="share-your-story"
                clickTagAction={`Filter by: ${filters}`}
                clickTagLabel="activity-type-filter"
                className="mb-0"
            >
                <div className="ugc-story-checkbox-wrap">
                    <Checkbox
                        id={`${id}-boating`}
                        label="Boating"
                        value="Boating"
                        isChecked={filters.includes('Boating')}
                        isDisabled={boatingTotal === 0}
                        onChange={onFilterChange}
                    />
                    <Badge>{boatingTotal}</Badge>
                </div>

                <div className="ugc-story-checkbox-wrap">
                    <Checkbox
                        id={`${id}-camping`}
                        label="Camping"
                        value="Camping"
                        isChecked={filters.includes('Camping')}
                        isDisabled={campingTotal === 0}
                        onChange={onFilterChange}
                    />
                    <Badge>{campingTotal}</Badge>
                </div>

                <div className="ugc-story-checkbox-wrap">
                    <Checkbox
                        id={`${id}-climbing`}
                        label="Climbing"
                        value="Climbing"
                        isChecked={filters.includes('Climbing')}
                        isDisabled={climbingTotal === 0}
                        onChange={onFilterChange}
                    />
                    <Badge>{climbingTotal}</Badge>
                </div>

                <div className="ugc-story-checkbox-wrap">
                    <Checkbox
                        id={`${id}-fishing`}
                        label="Fishing"
                        value="Fishing"
                        isChecked={filters.includes('Fishing')}
                        isDisabled={fishingTotal === 0}
                        onChange={onFilterChange}
                    />
                    <Badge>{fishingTotal}</Badge>
                </div>

                <div className="ugc-story-checkbox-wrap">
                    <Checkbox
                        id={`${id}-hiking`}
                        label="Hiking"
                        value="Hiking"
                        isChecked={filters.includes('Hiking')}
                        isDisabled={hikingTotal === 0}
                        onChange={onFilterChange}
                    />
                    <Badge>{hikingTotal}</Badge>
                </div>

                <div className="ugc-story-checkbox-wrap">
                    <Checkbox
                        id={`${id}-Hunting`}
                        label="Hunting"
                        value="Hunting"
                        isChecked={filters.includes('Hunting')}
                        isDisabled={huntingTotal === 0}
                        onChange={onFilterChange}
                    />
                    <Badge>{huntingTotal}</Badge>
                </div>

                <div className="ugc-story-checkbox-wrap">
                    <Checkbox
                        id={`${id}-ohv`}
                        label="Off-Highway Vehicle"
                        value="Off-Highway Vehicle"
                        isChecked={filters.includes('Off-Highway Vehicle')}
                        isDisabled={ohvTotal === 0}
                        onChange={onFilterChange}
                    />
                    <Badge>{ohvTotal}</Badge>
                </div>

                <div className="ugc-story-checkbox-wrap">
                    <Checkbox
                        id={`${id}-pet-friendly`}
                        label="Pet Friendly"
                        value="Pet Friendly"
                        isChecked={filters.includes('Pet Friendly')}
                        isDisabled={petFriendlyTotal === 0}
                        onChange={onFilterChange}
                    />
                    <Badge>{petFriendlyTotal}</Badge>
                </div>

                <div className="ugc-story-checkbox-wrap">
                    <Checkbox
                        id={`${id}-rv-camping`}
                        label="RV Camping"
                        value="RV Camping"
                        isChecked={filters.includes('RV Camping')}
                        isDisabled={rvCampingTotal === 0}
                        onChange={onFilterChange}
                    />
                    <Badge>{rvCampingTotal}</Badge>
                </div>

                <div className="ugc-story-checkbox-wrap">
                    <Checkbox
                        id={`${id}-water-sports`}
                        label="Water Sports"
                        value="Water Sports"
                        isChecked={filters.includes('Water Sports')}
                        isDisabled={waterSportsTotal === 0}
                        onChange={onFilterChange}
                    />
                    <Badge>{waterSportsTotal}</Badge>
                </div>

                <div className="ugc-story-checkbox-wrap">
                    <Checkbox
                        id={`${id}-wild-life-viewing`}
                        label="Wildlife Viewing"
                        value="Wildlife Viewing"
                        isChecked={filters.includes('Wildlife Viewing')}
                        isDisabled={wildlifeViewingTotal === 0}
                        onChange={onFilterChange}
                    />
                    <Badge>{wildlifeViewingTotal}</Badge>
                </div>
            </DropdownMenu>
        </FlexCol>
    );
}

StoryActivityFilter.propTypes = {
    aggregations: PropTypes.object,
    selectedFilters: PropTypes.array,
    onApply: PropTypes.func,
};
